import React from 'react';
import { hydrate, render } from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import './assets/styles/main.css';
import Root from './Root';
import Loading from './components/Loading/Loading';
import registerServiceWorker from './registerServiceWorker';
import configureStore from './store/index';

const { store, persistor } = configureStore();

const rootElement: HTMLElement|null = document.getElementById("root");

const rootApp: JSX.Element = (
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={<Loading />}>
      <Root />
    </PersistGate>
  </Provider>
);

if (rootElement && rootElement.hasChildNodes()) {
  hydrate(rootApp, rootElement);
} else {
  render(rootApp, rootElement);
}

if (!navigator.userAgent.match("ReactSnap")) {
  registerServiceWorker();
}



// WEBPACK FOOTER //
// ./src/index.tsx